<span id="calendario-reunioes"></span>

<div class="container">
  <div class="content">
    <h2 id="title">Calendário de reuniões</h2>
    <p>
      Acompanhe as reuniões do COMDICA, no Auditório do Centro Integrado de
      Apoio a Criança e Adolescente - CIACAP - Rua Dr. Carlos Matheus, nº 1444,
      Centro - Parnamirim/RN, ao lado do INSS.
    </p>

    <div class="calendar">
      <div
        class="meeting-card"
        *ngFor="let meet of meetings; index as i"
        [ngClass]="meet.active ? '' : 'old_month'"
      >

        <div class="date_item">
          <h2>{{ meet.day < 10 ? '0' + meet.day : meet.day }}</h2>
          <p>{{ meet.dayOfWeek }}</p>
        </div>

        <div class="month_item" [ngClass]="meet.currentMonth ? 'current_month' : 'other_month'">
          <div class="month-content">
            <p class="month-name">{{ meet.month }}</p>

            <div class="status">
              <img
                *ngIf="!meet.active"
                src="assets/images/icons/checked.svg"
                alt="Reunião já aconteceu"
                class="icon-checked"
              />
              <p *ngIf="meet.active" class="hour">{{ meet.meetingHour }}h</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <img id="calendar" src="/assets/images/images/calendar.svg" alt="calendario" />
</div>
